import { useId } from 'react';

interface TextareaProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  helperText?: string;
  /** Para um `FormField` em volta, que é dono do rótulo e do erro. */
  id?: string;
  invalid?: boolean;
  describedBy?: string;
  disabled?: boolean;
}

/**
 * Textarea da app. Fallback consciente: o design system não expõe textarea (só
 * `Input` single-line) e vários formulários precisam de múltiplas linhas —
 * bodies de conteúdo (enunciado, transcrição) e as justificativas das operações
 * de vendas. Estilo espelha o `Input`.
 */
export function Textarea({
  label,
  value,
  onChange,
  placeholder,
  rows = 3,
  helperText,
  id: externalId,
  invalid,
  describedBy,
  disabled,
}: TextareaProps) {
  const generatedId = useId();
  const id = externalId ?? generatedId;
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label
          htmlFor={id}
          className="text-(--color-text-primary) text-sm font-medium"
        >
          {label}
        </label>
      )}
      <textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        aria-describedby={describedBy}
        className="border-(--color-border) bg-(--color-bg-secondary) text-(--color-text-primary) placeholder:text-(--color-placeholder) focus:border-(--color-accent) focus:ring-(--color-accent)/20 w-full rounded-lg border px-3 py-2 text-sm outline-none transition-colors focus:ring-2 disabled:opacity-60"
      />
      {helperText && (
        <p className="text-(--color-text-secondary) text-xs">{helperText}</p>
      )}
    </div>
  );
}
